<template>
<div v-if="$yagi.isYagiDaikon">
  <div class="omikuji-area"
    :class="rarityClass"
    v-if="omikuji">
    <div>{{ rarityLabel }}</div>
    <div v-if="errorMessage"> {{ errorMessage }}</div>
    <div v-if="nowLoding"
      class="now-loading"
      :class="rarityClass">
      <i class="el-icon-loading"></i>
    </div>
    <div v-else>
      <a :href="omikujiUrl"><img v-if="omikujiSrc"
           :src="omikujiSrc"
           class="omikuji-result-img"></a>
    </div>
    <div class="close-button"
      v-if="omikuji">
      <!--{{ rateTable }}-->
      <el-button type="text"
        @click="omikuji=null">閉じる</el-button>
    </div>
  </div>
</div>
</template>
<style scoped>
.omikuji-result-img {
  max-width: 100%;
  height: auto;
}

.now-loading {
  font-size: 160px
}

.rarity-1 {
  background-color: white;
}

.rarity-2 {
  background-color: lightcyan;
}

.rarity-3 {
  background-color: skyblue;
}

.rarity-4 {
  background-color: plum;
}

.rarity-5 {
  background-color: gold;
}
</style>

<script>
import omikujiTableRaw from '@/assets/omikuji/index'
import _ from '@/assets/lib/my-lodash'
const raritySetting = {
  1: 100,
  2: 50,
  3: 25,
  4: 12,
  5: 6
}
const rarityTable = (() => {
  let table = []
  for (const rarity in raritySetting) {
    const rarityArray = _.fill(new Array(raritySetting[rarity]), rarity)
    table = table.concat(rarityArray)
  }
  return table
})()
// const GOSENCHOEN_API_URL = 'https://gosenchoen-dot-hcep-pdf.appspot.com'
const GOSENCHOEN_API_URL = process.env.VUE_APP_GOSENCHOEN_API_URL

const sleep = (waitSeconds, someFunction) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(someFunction())
    }, waitSeconds)
  })
}

export default {
  data: function () {
    return {
      omikuji: null,
      omikujiTable: [],
      omikujiSrc: '',
      omikujiUrl: '',
      imgSrcTop: '',
      imgSrcBottom: '',
      nowLoding: false,
      errorMessage: ''
    }
  },
  computed: {
    rarityClass: function () {
      const classObj = {}
      if (this.omikuji) {
        classObj['rarity-' + this.omikuji.rarity] = true
      }
      return classObj
    },
    rarityLabel: function () {
      if (!this.omikuji.emoji) return ''
      return this.omikuji.emoji.repeat(this.omikuji.rarity)
    },
    rateTable: function () {
      let sum = 0
      const rate = {}
      for (const val in raritySetting) {
        sum += raritySetting[val]
      }
      for (const key in raritySetting) {
        rate[key] = (raritySetting[key] / sum * 100).toFixed(2)
      }
      return rate
    }
  },
  methods: {
    loadOmikujiTable: function () {
      const table = []
      for (const r of omikujiTableRaw) {
        table.push({
          rarity: r[0],
          messages: [r[1], r[2]],
          emoji: r[3]
        })
      }
      this.omikujiTable = table
    },
    getRarity: function () {
      return _.sample(rarityTable)
    },
    getOmikuji: function (rarity) {
      const result = _.sample(this.omikujiTable.filter(omikuji => Number(omikuji.rarity) === Number(rarity)))
      if (result) {
        return result
      } else {
        console.error('getOmikuji failed')
      }
    },
    $_createOmikujiParams: function (omikuji) {
      return {
        line1: omikuji.messages[0],
        line2: omikuji.messages[1],
        rarity: omikuji.rarity,
        emoji: omikuji.emoji
      }
    },
    pullOmikuji: async function (isTest) {
      if (this.nowLoding) return
      this.nowLoding = true
      this.omikuji = {}
      this.errorMessage = ''
      const rarity = this.getRarity()
      await sleep(rarity * 200 + 150, () => {})
      this.omikuji = this.getOmikuji(rarity)
      await sleep(450 * rarity + 150, () => {})
      this.$axios.get(GOSENCHOEN_API_URL, {
        params: this.$_createOmikujiParams(this.omikuji),
        responseType: 'arraybuffer'
      }).then(response => {
        this.omikujiUrl = response.request.responseURL
        this.omikujiSrc = 'data:image/png;base64,' + Buffer.from(response.data).toString('base64')
        this.nowLoding = false
        const app = this
        this.$firebase.addOmikujiLog(this.omikuji)
          .then(function (docRef) {
            console.log('おみくじ保存成功', docRef.id)
          })
          .catch(function (error) {
            console.error(error)
            app.$message({
              type: 'error',
              message: 'おみくじ保存失敗'
            })
          })
      }).catch(err => {
        console.log(err)
        this.errorMessage = err
        this.nowLoding = false
      })
    }
  },
  beforeMount: function () {
    this.loadOmikujiTable()
    this.$eventHub.$on('pull-omikuji', this.pullOmikuji)
  },
  mounted: function () {},
  destroyed: function () {
    this.$eventHub.$off('pull-omikuji', this.pullOmikuji)
  }
}
</script>
